module.exports = __webpack_public_path__ + "media/images/hrms/google-plus-circled-9041aee222d2ff321cef40c9dfed4a45.png";